import { createSlice } from '@reduxjs/toolkit';

interface SessionState {
  hasSession: boolean;
  lastChecked: number | null;
}

const initialState: SessionState = {
  hasSession: false,
  lastChecked: null,
};

// Separate slice just for session state
export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setHasSession: (state, action) => {
      state.hasSession = action.payload;
      state.lastChecked = Date.now();
    },
    clearSession: (state) => {
      state.hasSession = false;
      state.lastChecked = null;
    },
  },
});

export const { setHasSession, clearSession } = sessionSlice.actions;
export default sessionSlice.reducer;